import { Address } from "../api/services";

export const formatAddress = (address: Address): string => {
  return Object.values(address!).reduce((output, value, index) => {
    if (value && value.length > 0) {
      if (output === "") {
        output = value;
      } else {
        output += `, ${value}`;
      }
    }
    return output;
  }, "") as string;
};
